import React, { createContext, useContext, useState } from "react";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [globalProfile, setGlobalProfile] = useState("");
  return (
    <GlobalContext.Provider value={{ globalProfile, setGlobalProfile }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => useContext(GlobalContext);
